import type { Controls } from "@obean/game-contract";
import { mergeControls } from "./controls.js";
import { KeyboardInput } from "./keyboard.js";
import { TouchInput } from "./touch.js";

export { TouchControls, TouchInput } from "./touch.js";
export { keyboardHint } from "./controls.js";
export type { ControlButtons } from "./controls.js";

/**
 * Every input device on this page as one device-neutral Controls stream (keyboard and touch today;
 * a gamepad source fits the same shape). Sample it once per simulation step.
 */
export class PlayerInput {
  readonly touch = new TouchInput();
  readonly #keyboard = new KeyboardInput();

  sample(): Controls {
    return mergeControls([this.#keyboard.sample(), this.touch.sample()]);
  }

  dispose(): void {
    this.#keyboard.dispose();
  }
}
